import { gql } from "@stadium/services/apollo-client";
import { USER_LOGO_STATUS } from "@stadium/hooks/graphql/fragments/user/logo-status";

export const updateDummyStore = gql`
  mutation UpdateDummyStore($input: UpdateDummyStoreInput!) {
    updateDummyStore(input: $input) {
      dummyStore {
        id
        logo
        taxonIds
        topBanner
        currency
        banner {
          id
          privateMetadata
        }
        maxPrice
        minPrice
      }
      errors
      user {
        ...UserLogoStatus
      }
    }
  }
  ${USER_LOGO_STATUS}
`;
